export default "__VITE_ASSET__CCux_LKc__"